import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { restoreAll } from '../restoreAll';
import { ViewToggleType } from '../../components/Projects/ViewToggle';

export type ProjectsSortBy = 'NAME' | 'CLIENT' | 'START_DATE' | 'END_DATE' | 'STATUS';

export interface ProjectsUiState {
    searchTerm: string;
    selectedFilters: string[];
    view: ViewToggleType;
    sortBy: ProjectsSortBy;
    sortDirection: 'ASC' | 'DESC';
    pagination: {
        client: {
            page: number;
            elementsPerPage: number;
        };
        normal: {
            page: number;
            elementsPerPage: number;
        };
    };
}

const initialState: ProjectsUiState = {
    searchTerm: '',
    selectedFilters: [],
    view: 'list',
    sortBy: 'NAME',
    sortDirection: 'ASC',
    pagination: {
        client: {
            page: 0,
            elementsPerPage: 5,
        },
        normal: {
            page: 0,
            elementsPerPage: 10,
        },
    },
};

const projectsUiSlice = createSlice({
    name: 'projectsUi',
    initialState,
    reducers: {
        setSearchTerm(state, action: PayloadAction<string>) {
            state.searchTerm = action.payload;
        },
        setSelectedFilters(state, action: PayloadAction<string[]>) {
            state.selectedFilters = action.payload;
        },
        setView(state, action: PayloadAction<ViewToggleType>) {
            state.view = action.payload;
        },
        setSort(
            state,
            action: PayloadAction<{
                sortBy: ProjectsSortBy;
                sortDirection: 'ASC' | 'DESC';
            }>
        ) {
            state.sortBy = action.payload.sortBy;
            state.sortDirection = action.payload.sortDirection;
        },
        setPage: (state, action: PayloadAction<{ context: 'client' | 'normal'; page: number }>) => {
            state.pagination[action.payload.context].page = action.payload.page;
        },

        setElementsPerPage: (state, action: PayloadAction<{ context: 'client' | 'normal'; value: number }>) => {
            state.pagination[action.payload.context].elementsPerPage = action.payload.value;
        },
        resetProjectsUi: () => initialState,
    },
    extraReducers: builder => {
        builder.addCase(restoreAll, () => initialState);
    },
});

export const { setSearchTerm, setSelectedFilters, setView, setSort, resetProjectsUi, setPage, setElementsPerPage } = projectsUiSlice.actions;

export default projectsUiSlice.reducer;
